import { pipe, curry, isFunction } from "./function"
import { compactMap, join } from "./array"

export const split = curry((sep, str) => (isFunction(str && str.split) ? str.split(sep) : []))

export const trim = str => (isFunction(str && str.trim) ? str.trim() : "")

export const upperCase = str => (isFunction(str && str.toUpperCase) ? str.toUpperCase() : "")

export const lowerCase = str => (isFunction(str && str.toLowerCase) ? str.toLowerCase() : "")

export const removeLeadingWhitespace = string => string.replace(/^\s+/i, "")

export const removeTrailingWhitespace = string => string.replace(/\s+$/i, "")

export const upperFirst = str =>
  (isFunction(str && str.slice) ? `${upperCase(str.slice(0, 1))}${lowerCase(str.slice(1))}` : "")

export const titleCase = pipe(split(/\s/g), compactMap(pipe(trim, upperFirst)), join(" "))



// WEBPACK FOOTER //
// ./src/utils/string.js